import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {
    linkTargets,
    reusableComponentSizes,
    buttonStyleTypes
} from "core/props";

import colors from "core/colors";
import { MaterialUIGridContainer } from "core/MaterialUI";
import Heading from "core/Heading";
import BodyText from "core/BodyText";
import Button from "core/Button";

import { GridItem, SupportingIcons } from "./styles";

const UnstyledFourUp = ({ boxes }) => {
    return (
        <MaterialUIGridContainer
            mobileMaxPadding={6} // 32px spacing between elements
            tabletMaxPadding={8} // 40px spacing between elements
            desktopMinPadding={8} // 40px spacing between elements
            justify="center"
        >
            {boxes.map((box, index) => {
                return (
                    <GridItem item sm={12} md={6} lg={3} key={index}>
                        <Heading
                            type="p"
                            size="sm"
                            headingColor={colors.midnight}
                        >
                            {box.heading}
                        </Heading>

                        <SupportingIcons>
                            {box.images.map(image => {
                                return image;
                            })}
                        </SupportingIcons>

                        <BodyText
                            type="p"
                            size="lg"
                            copyColor={colors.midnight}
                        >
                            {box.text}
                        </BodyText>

                        {box.buttons.map((button, index) => {
                            return (
                                <Button
                                    key={index}
                                    size={button.size}
                                    styleType={button.type}
                                    darkMode={button.darkMode}
                                    href={button.href}
                                    target={button.target}
                                    onClick={button.onClick}
                                >
                                    {button.text}
                                </Button>
                            );
                        })}
                    </GridItem>
                );
            })}
        </MaterialUIGridContainer>
    );
};

const FourUp = styled(UnstyledFourUp)``;

FourUp.propTypes = {
    boxes: PropTypes.arrayOf(
        PropTypes.shape({
            heading: PropTypes.string.isRequired,
            images: PropTypes.array,
            text: PropTypes.string.isRequired,
            buttons: PropTypes.arrayOf(
                PropTypes.shape({
                    text: PropTypes.any,
                    size: PropTypes.oneOf(reusableComponentSizes),
                    styleType: PropTypes.oneOf(buttonStyleTypes),
                    darkMode: PropTypes.bool,
                    href: PropTypes.string,
                    target: PropTypes.oneOf(linkTargets),
                    onClick: PropTypes.func
                })
            )
        })
    ).isRequired
};

export default FourUp;
